export class CoreActions {
  static readonly GET_TAGS = '[CORE] GET_TAGS';
  static readonly GET_PREFERENCES = '[CORE] GET_PREFERENCES';
  static readonly SET_PREFERENCES = '[CORE] SET_PREFERENCES';
  static readonly GET_PROJECTS = '[CORE] GET_PROJECTS';
  static readonly GET_CONTACTS = '[CORE] GET_CONTACTS';

}

